import React from 'react';
import ReactPaginate from 'react-paginate';

const PaginationTreatment = ({ rows, page, pages, msg, changePage }) => {
  return (
    <div style={{ display: "flex", padding: "10px" }}>
      <div>
        <div style={{ fontSize: "12px" }}>
          Total Rows: {rows}
        </div>
        <div style={{ fontSize: "12px" }}>
          Page: {rows ? page : 0} of {pages}
        </div>
        <p className="has-text-centered has-text-danger">{msg}</p>
      </div>
      <div style={{ flex: "50%", display: "flex", justifyContent: "end" }}>
        <nav
          style={{ fontSize: "12px" }}
          className="pagination is-centered"
          key={rows}
          role="navigation"
          aria-label="pagination"
        >
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            pageCount={Math.min(10, pages)} // Membatasi jumlah halaman yang ditampilkan
            onPageChange={changePage} // Fungsi untuk mengubah halaman
            containerClassName={"pagination-list"} // Kelas untuk elemen list
            pageLinkClassName={"pagination-link"} // Kelas untuk setiap link halaman
            previousLinkClassName={"pagination-previous"} // Kelas untuk tombol sebelumnya
            nextLinkClassName={"pagination-next"} // Kelas untuk tombol berikutnya
            activeLinkClassName={"pagination-link is-current"} // Kelas untuk halaman aktif
            disabledLinkClassName={"pagination-link is-disabled"} // Kelas untuk link yang dinonaktifkan
          />
        </nav>
      </div>
    </div>
  );
};

export default PaginationTreatment;
